// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.R6DpOXjOE7WALrOkzjED{background-color:#ff0}`, "",{"version":3,"sources":["webpack://./src/components/text-highlighter/TextHighlighter.module.scss"],"names":[],"mappings":"AAAA,sBACE,qBAAA","sourcesContent":[".highlight {\n  background-color: yellow;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"highlight": `R6DpOXjOE7WALrOkzjED`
};
export default ___CSS_LOADER_EXPORT___;
